{
    "CallsansweredwithinLabel": "Le chiamate devono essere risposte entro:",
    "CallsansweredwithinPlaceholder": "10",
    "CallsansweredwithinUnit": "s",
    "ServiceLvlSettings_SectionHeader": "Impostazioni del livello di servizio",
    "ServiceLvlSettings_SectionPara": "È possibile regolare le seguenti impostazioni per controllare in modo specifico il modo in cui il report corrente calcola la statistica \"% Livello di servizio\" quando è supportata dallo stile di report scelto ed è anche selezionata per la visualizzazione.",
    "ServiceLvlSettings_IgnorequickabndcallswithinLabel": "Ignorare le chiamate rapide abbandonate all'interno:",
    "ServiceLvlSettings_IgnorequickabndcallswithinPlaceholder": "5",
    "ServiceLvlSettings_IgnorequickabndcallswithinEnabledHiddenlabel": "L'impostazione \"Ignora chiamate rapide abbandonate\" è abilitata?",
    "ServiceLvlSettings_IgnorequickabndcallswithinUnit": "s",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinLabel": "Ignorare le chiamate in eccesso all'interno:",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinPlaceholder": "5",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinEnabledHiddenlabel": "L'impostazione \"Ignora le chiamate in overflow all'interno\" è abilitata?",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinUnit": "s",
    "NAME": "ServiceLvlSettings"
}